import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { reportCategoryProduct } from 'utils/breadcrumbInfo';
import { roundToDecimalPlace } from 'utils/helpers';
import { getProductTypes } from 'actions/EntityActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import { getCategoryProducts, getCsvReport } from 'actions/ReportsAction';
// Basic Components
import Body from './Body';
import Header from './Header';
import CardSimple from 'screens/components/basic/CardSimple';
import PageHeader from 'screens/components/basic/PageHeader';
import Grid from 'screens/components/basic/Grid';

import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';

const CategoryProduct = () => {
    // Redux State
    const dispatch = useDispatch();
    const {
        CategoryProductsDate: date,
        CategoryProductsBranchOption: branch,
        CategoryProductsSelectedCategory: selectedCategory,
        CategoryProductsIsCannabis: isCannabis,
        CategoryProductsComparisonDate: comparisonDate,
        CategoryProductsShowCompare: showComparison,
        CategoryProductsPlotDropdown: selectedPlot
     } = useSelector(state => state.form || {});
    const { categoryProducts = [] } = useSelector(state => state.reports || {});
    const { productTypesList: productTypes = [] } = useSelector(state => state.entity || {});
    const { branchId: loggedBranch, userBranches = [] } = useSelector(state => state.common || {});
    const brachOptions = [];
    userBranches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    });
    const isCannabisOptions = [
        {text: "All", value: "2"},
        {text: "Cannabis", value: "1"},
        {text: "Non-Cannabis", value: "0"}
    ];

    // Local State
    const [activePage, setActivePage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(40);
    const [showBody, setShowBody] = useState(false);
    const [dataForPlotting, setDataForPlotting] = useState([]);
    const [selectedPlotNames, setSelectedPlotNames] = useState([
        "Units",
        "Compare Units",
        "Number of Units per Category"
    ]);

    useEffect(() => {
        const date = new Date()
        dispatch(formInput(new Date(date.getFullYear(), date.getMonth(), date.getDate()), `CategoryProductsDate`));
        dispatch(formInput(new Date(date.getFullYear(), date.getMonth(), date.getDate()), `CategoryProductsComparisonDate`));
        dispatch(getProductTypes());

        return () => cleanSearch();
    }, []);


    useEffect(() => {
        if (categoryProducts){
            setDataForPlotting(getDataForPlotting(categoryProducts));
        }
    }, [categoryProducts]);


    useEffect(() => {
        getSelectedPlotNames(selectedPlot)
    }, [selectedPlot]);

    useEffect(() => {
        getReport();
    }, [activePage])

    const cleanSearch = () => {
        dispatch(clearFormInput(`CategoryProductsDate`));
        dispatch(clearFormInput(`CategoryProductsBranchOption`));

        setActivePage(1);
        getReport();
    }

    const downloadReport = () => {
        let dateLocal = date ? moment(date).format('YYYY-MM-DD') : moment().add('day').format('YYYY-MM-DD');
        let branchLocal = branch || loggedBranch;

        dispatch(getCsvReport(`reports/excel/categoryproduct?date=${dateLocal}&branch=${branchLocal}&isCannabis=${isCannabis}&selectedCategory=${selectedCategory}`, "CategoryProduct"));
    }

    const filter = () => {
        setActivePage(1);
        getReport();
    }

    const getReport = () => {
        let dateLocal = date ? moment(date).format('YYYY-MM-DD') : moment().add('day').format('YYYY-MM-DD');
        let branchLocal = branch || loggedBranch;
        let pageNumber = activePage;
        let pageSize = itemsPerPage;
        let comparisonDateLocal = comparisonDate ? moment(comparisonDate).format('YYYY-MM-DD') : moment().add('day').format('YYYY-MM-DD');
        dispatch(getCategoryProducts({ date: dateLocal, pageNumber, pageSize, branch: branchLocal, isCannabis, selectedCategory, comparisonDate: comparisonDateLocal }));
    }

    const showBodyContent = () =>{
        filter();
        setShowBody(true);
    }

    const getDataForPlotting = (categoryProducts) => {
        const finalArray = [];
            categoryProducts.list && categoryProducts.list.map(item => {
                let found = categoryProducts.compare.find(x => x.categoryId === item.categoryId);
                const newItem = {
                    categoryId: item.categoryId,
                    categoryName: item.categoryName,
                    units: item.quantity,
                    cost: item.cost,
                    margin: roundToDecimalPlace(item.marginPercentage, 2),
                    markup: roundToDecimalPlace(item.markupPercentage, 2),
                    compareUnits: found ? found.quantity : 0,
                    compareCost: found ? found.cost : 0,
                    compareMargin: found ? roundToDecimalPlace(found.marginPercentage, 2) : 0,
                    compareMarkup: found > 0 ? roundToDecimalPlace(found.markupPercentage, 2) : 0
                }
                finalArray.push(newItem);
            })
        return finalArray
    }

    const getSelectedPlotNames = (selectedPlot) => {
        switch (selectedPlot) {
            case "Units":
                setSelectedPlotNames(["Units", "Compare Units", "Number of Units per Category"])
                break;
            case "Cost":
                setSelectedPlotNames(["Cost", "Compare Cost", "Total Cost in Inventory per Category"])
                break;
            case "Margin %":
                setSelectedPlotNames(["Margin %", "Compare Margin %", "Margin % per Category"])
                break;
            case "Markup %":
                setSelectedPlotNames(["Markup %", "Compare Markup %", "Markup % per Category"])
                break;
        }
    }

    const customTooltip = ({ payload, label, active }) => {
        if (active && payload.length > 0) {
            // console.log(payload);
            let data = payload[0].payload;

            return (

                <div className="custom-tooltip">
                    <h5 className="primary-color-text">{data.categoryName}</h5>
                    <table>
                        <tr className="purple-text fw_bold">
                            <td>{selectedPlotNames[0]}</td>
                            <td>{selectedPlotNames[0] == "Cost" ? "$" : ""}
                                {data[`${selectedPlotNames[0]}`]}
                                {selectedPlotNames[0] == "Margin %" || selectedPlotNames[0] == "Markup %" ? "%" : ""}
                            </td>
                        </tr>
                        {showComparison &&
                            <tr className="orange-text fw_bold">
                                <td>{selectedPlotNames[1]}</td>
                                <td>{selectedPlotNames[0] == "Cost" ? "$" : ""}
                                    {data[`${selectedPlotNames[1]}`]}
                                    {selectedPlotNames[0] == "Margin %" || selectedPlotNames[0] == "Markup %" ? "%" : ""}
                                </td>
                            </tr>}

                    </table>

                </div>
            );
        }

        return null;
    }

    let categories = [];
    const cat = productTypes.length > 0 ? productTypes[0].categories : [];
    cat.map(item => {
        categories.push({
            text: item.name,
            value: item.id.toString(),
            isCannabis: item.isCannabis
        });
    });

    categories.sort((a, b) => {
        if (a.text < b.text)
            return -1;
        if (a.text > b.text)
            return 1;
        return 0;
    });

    categories.unshift({ text: "All", value: "0", isCannabis: false }, { text: "All", value: "0", isCannabis: true });

    return (
        <Grid headerContent={reportCategoryProduct}>
            <PageHeader title={LOOKUP.report.productbycategory.text}
                description={LOOKUP.report.productbycategory.description}
            />
            <Header
                branchOptions={brachOptions}
                filter={filter}
                download={downloadReport}
                showBody={showBodyContent}
                loggedBranch={loggedBranch}
                categories={categories}
                isCannabis={isCannabis}
                isCannabisOptions={isCannabisOptions}
            />
            {showBody &&
                <React.Fragment>
                    <DateCurrentDisplay />
                    <CardSimple>
                        <Body
                            categoryProducts={categoryProducts}
                            showComparison={showComparison}
                            dataForPlotting={dataForPlotting}
                            selectedPlotNames={selectedPlotNames}
                            customTooltip={customTooltip}
                        />
                    </CardSimple>
                </React.Fragment>
            }
        </Grid>
    );

}

export default CategoryProduct;